import React from 'react';
import { render } from 'react-dom';
import Auth from './auth/auth';
import './index.css';
import StockwatchRouter from './StockwatchRouter';

// Check if we are logged in
Auth.checkIfLoggedInOnServer(() => {
  // This methods initializes the routing on the page.
  render(
    React.createElement(StockwatchRouter),
    document.getElementById('root')
  );
});
